<div [class]="outerContainerClasses()">
    <span class="ds-tooltip-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11">
            <path d="M11.5364 10.1563C10.7369 11.1158 9.26315 11.1158 8.46356 10.1563L0 0L20 0L11.5364 10.1563Z" fill="currentColor" />
        </svg>
    </span>
    @if (!customTooltip()) {
        <div class="ds-tooltip-container">
            <div class="ds-tooltip-text-container">
                <div class="ds-tooltip-text">
                    <div [id]="tooltipId() + '-title'" class="ds-tooltip-title">
                        <ng-content select="[slot=title]" />
                        @if (tooltipTitle()) {
                            <span class="sr-only">{{ tooltipTitle() }}</span>
                        }
                    </div>
                    <ng-content select="[slot=description]" />
                </div>
                <div class="ds-tooltip-close-button" (click)="closeTooltip($event)" (keydown)="handleKeydown($event)">
                    <ng-content select="[slot=close]" />
                </div>
            </div>
            <ng-content select="[slot=action]" />
        </div>
    } @else {
        <ng-content />
    }
</div>
